<template>
  <div class="container">
    <div class="vue flex">
      <div class="leftNav">
        <div class="logo flex flexAi-c flexJc-c">
          <img :src="require('@/assets/image/public/logo.png')" alt="" />
        </div>
        <el-menu
          style="border-bottom:0;"
          class="el-menu-demo"
          active-text-color="#fff"
          router
          :default-active="$route.path"
        >
          <el-submenu
            v-for="(item, index) in items"
            :key="index"
            :index="item.url"
          >
            <template slot="title">{{ item.name }}</template>
            <el-menu-item
              v-for="(row, i) in item.list"
              :key="i"
              :index="row.url"
            >
              <span slot="title">{{ row.name }}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="rightCon">
        <div class="header flex flexJc-fe flexAi-c">
          <div class="right">
            <el-button
              @click="withdrawClick"
              size="medium"
              icon="el-icon-circle-close"
              >退出登录</el-button
            >
          </div>
        </div>
        <div class="cotant">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiSignOut } from '@/api/backgroundViews'

export default {
  name: '',
  props: [''],
  data() {
    return {
      items: [
        {
          name: '人员管理',
          url: '1',
          list: [{ name: '用户管理', url: '/userManage' }]
        },
        {
          name: '文章管理',
          url: '2',
          list: [
            { name: '文章列表', url: '/articleList' },
            { name: '栏目列表', url: '/columnList' }
          ]
        }
      ]
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {},

  methods: {
    // 退出登录
    withdrawClick() {
      apiSignOut().then(res => {
        if (res.status === '0') {
          this.$message.error(res.data)
          localStorage.removeItem('Token') // 移除所有的缓存数据
          setTimeout(() => {
            this.$router.push('/')
          }, 1000)
        } else if (res.status === '1') {
          this.$message.error(res.data)
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
$padding: 10px;
.vue {
  .leftNav {
    text-align: center;
    width: 15%;
    .logo {
      height: 6vh;
      padding: $padding;
      img {
        width: 100px;
        height: 36px;
      }
      span {
        padding-left: 6px;
      }
    }
    .el-menu {
      height: 94vh;
    }
    .el-menu-item.is-active {
      background-color: #319f8f !important;
    }
  }
}
.rightCon {
  width: 85%;
  .header {
    height: 6vh;
    color: #59607b;
    align-items: center;
    padding: $padding;
    border-bottom: 1px solid #d9d9d9;
    .right {
      .el-dropdown-link {
        cursor: pointer;
      }
    }
  }
  .cotant {
    height: 94vh;
    padding: $padding + 10px;
    background-color: #e5e6ee;
  }
}
</style>
